import { zodContract } from '@farfetched/zod';
import { createStore, Store } from 'effector';
import { createAuthQuery } from '../auth-http-client';
import { deviceSchema } from '../types';

export const createGetDevicesQuery = ($gameId?: Store<number | null>) =>
	createAuthQuery({
		request: {
			method: 'GET',
			url: '/device',
			query: {
				source: $gameId ?? createStore(null),
				fn: (_, gameId) => ({
					gameId,
				}),
			},
		},
		response: {
			contract: zodContract(deviceSchema.array()),
		},
	});
